export enum SwaggerFile {
  collection = '/docs/swagger/collection.json',
  payouts = '/docs/swagger/payouts.json',
  authentication = '/docs/swagger/authentication.json',
  reconciliation = '/docs/swagger/reconciliation.json',
  customer_app_api = '/docs/swagger/customer_app_api.json',
  fx = '/docs/swagger/fx.json'
}
